import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ReactTable from 'react-table'
import moment from 'moment'
import _ from 'lodash'
import { message, Tooltip, Popconfirm, Button } from 'antd'
import numeral from 'numeral'
import { filterCaseInsensitive, getModalId } from '../../../util'
import Loader from '../../common/Loader'
import { actions as jobSiteEstimateActions } from '../../../redux/modules/jobFunctions/jobSiteEstimateActions'
import { actions as estimateTemplateActions } from '../../../redux/modules/jobFunctions/estimateTemplateActions'
import { actions as itemActions } from '../../../redux/modules/jobFunctions/itemActions'
import { actions as jobVendorActions } from '../../../redux/modules/jobFunctions/jobVendorActions'
import { actions as jobSiteChangeOrderActions } from '../../../redux/modules/jobFunctions/jobSiteChangeOrderActions'
import { actions as revisionActions } from '../../../redux/modules/revisionActions'
import history from '../../../history'
import { Modal as ModalRouter } from 'react-router-modal'
import JobSiteEstimatesModal from './JobSiteEstimatesModal'

const propTypes = {}
class JobSiteEstimates extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      cloningMode: false
    }

    this.props.getAllItems()
    this.props.getAllVendors()
    this.props.getEstimateTemplates()
  }

  componentDidMount() {
    this.props.jobSiteEstimatesRefresh({
      jobId: this.props.jobId,
      next: (err, payload) => {
        const estimateId = getModalId(this.props.location.pathname)
        if (estimateId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(estimateId, 10) })
            if (current) {
              this.setState({
                contentData: current,
                currentId: current.id
              })

              this.props.getRevisions({
                targetId: current.id,
                table: 'estimate'
              })
              this.props.getEstimateSections(current.id)
              this.props.getEstimateItems(current.id)
            } else {
              message.warning('This Purchase Order was deleted or does not exist.')
            }
          }
        }
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.jobSiteEstimateActions.jobSiteEstimates !==
        prevProps.jobSiteEstimateActions.jobSiteEstimates
    ) {
      const highLightEstimate = _.filter(
        this.props.jobSiteEstimateActions.jobSiteEstimates.data,
        estimate => estimate.id === parseInt(this.props.shortcutItemId, 10)
      )
      this.handleRowClick(highLightEstimate[0])
      this.props.clearHighlight()
    }
  }

  handleRowClick = row => {
    const { jobId, jobType } = this.props.match.params
    this.props.getRevisions({
      targetId: row.id,
      table: 'estimate'
    })
    this.setState({
      currentId: row.id,
      contentData: row
    })

    history.push(`/jobView/${jobId}/${jobType}/site-estimates/modal/${row.id}`)

    this.props.getEstimateSections(row.id)
    this.props.getEstimateItems(row.id)
  }

  handleAddButton = () => {
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/site-estimates/modal/0`)
    this.setState({
      currentId: 0,
      contentData: null
    })
  }

  handleCancel = () => {
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/site-estimates`)
    this.setState({
      contentData: null
    })
  }

  loadTemplateData = templateId => {
    this.props.getTemplateSections(templateId)
    this.props.getTemplateItems(templateId)
  }

  loadEstimateData = estimateId => {
    this.props.getEstimateSections(estimateId)
    this.props.getEstimateItems(estimateId)
  }

  confirmDelete = event => {
    this.props.deleteJobSiteEstimate({
      jobId: this.props.jobId,
      estimateId: this.state.currentId
    })

    message.success('Record deleted.')
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/site-estimates`)
    this.setState({
      contentData: null
    })
  }

  handleFireWrapUpEstimate = fire => {
    this.setState({
      wrapUpEstimate: fire
    })
  }

  getSelectedTemplate = value => {
    const selectedTemplate = this.props.estimateTemplate.estimateTemplates.data.find(
      template => template.name === value
    )
    return selectedTemplate ? +selectedTemplate.id : +value
  }

  handleWrapUpEstimate = _.debounce(
    estimate => {
      const estimateInfo = { ...estimate.estimateData, ...estimate.estimateTotals }
      const { currentId } = this.state

      // sanitize the selected template
      estimateInfo.estimate_template_id = this.getSelectedTemplate(
        estimateInfo.estimate_template_id
      )

      // clean data
      estimateInfo.tax = estimateInfo.tax / 100
      estimateInfo.markup = estimateInfo.markup / 100
      estimateInfo.overhead = estimateInfo.overhead / 100

      if (currentId === 0) {
        this.props.createJobSiteEstimate({
          jobId: this.props.jobId,
          content: estimateInfo,
          estimateSections: estimate.estimateSections,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateJobSiteEstimate({
          jobId: this.props.jobId,
          estimateId: currentId,
          content: estimateInfo,
          estimateSections: estimate.estimateSections,
          userId: this.props.user.userId
        })
      }

      message.success('Changes saved.')
      const { jobId, jobType } = this.props.match.params
      history.push(`/jobView/${jobId}/${jobType}/site-estimates`)
      this.setState({
        contentData: null,
        wrapUpEstimate: false,
        cloningMode: false
      })
    },
    1000,
    { leading: true, trailing: false }
  )

  changeContentData = (value, field) => {
    const tmpContentData = this.state.contentData
    tmpContentData[`${field}`] = value
    this.setState({
      contentData: tmpContentData
    })
  }

  handleClone = row => {
    this.handleRowClick(row)

    this.setState({
      cloningMode: true,
      currentId: 0
    })
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  render() {
    const templates = _.get(this.props, 'estimateTemplate.estimateTemplates.data')
    const items = _.get(this.props, 'itemActions.allItems.data')
    const templateSections = _.get(this.props, 'estimateTemplate.templateSections.data')
    const templateItems = _.get(this.props, 'estimateTemplate.templateItems.data')
    const estimateSections = _.get(
      this.props,
      'jobSiteEstimateActions.jobSiteEstimateSections.data'
    )
    const estimateItems = _.get(this.props, 'jobSiteEstimateActions.jobSiteEstimateItems')
    const revisions = _.get(this.props, 'revisionActions.revisions')
    const loadingRevision = _.get(this.props, 'revisionActions.loading')
    const jobSiteEstimates = _.get(this.props, 'jobSiteEstimateActions.jobSiteEstimates.data')

    if (!jobSiteEstimates) {
      return <Loader />
    }
    return (
      <div className="jobEstimate">
        {this.shouldRenderModal() && (
          <ModalRouter
            path="/job/:jobId/:jobType/site-estimates/modal/:estimateId"
            exact
            component={JobSiteEstimatesModal}
            props={{
              handleCancel: this.handleCancel,
              handleFireWrapUpEstimate: this.handleFireWrapUpEstimate,
              contentData: this.state.contentData,
              templates: templates,
              items: items,
              loadTemplateData: this.loadTemplateData,
              loadEstimateData: this.loadEstimateData,
              templateSections: templateSections,
              templateItems: templateItems,
              estimateSections: estimateSections,
              estimateItems: estimateItems,
              currentId: this.state.currentId,
              confirmDelete: this.confirmDelete,
              wrapUpEstimate: this.state.wrapUpEstimate,
              handleWrapUpEstimate: this.handleWrapUpEstimate,
              changeContentData: this.changeContentData,
              revisions: revisions,
              loadingRevision: loadingRevision,
              cloningMode: this.state.cloningMode
            }}
          />
        )}
        <div className="jobsBar">
          Estimate
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              CREATE Estimate
            </div>
          </div>
        </div>
        {jobSiteEstimates && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: () => {
                if (column.Header !== 'Clone') {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={jobSiteEstimates}
            columns={[
              {
                columns: [
                  {
                    Header: 'ID',
                    accessor: 'id',
                    maxWidth: 100
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 170
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                    width: 160,
                    Cell: d => {
                      const r = `${d.original.created_by_first_name} ${
                        d.original.created_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Updated By',
                    id: 'updated_by',
                    accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                    width: 160,
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name} ${
                        d.original.updated_by_last_name
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Grand Total',
                    id: 'grand_total',
                    accessor: d => numeral(d.grand_total).format('$0,0.00'),
                    maxWidth: 120,
                    className: 'textAlignRight'
                  },
                  {
                    Header: 'Clone',
                    accessor: 'clone',
                    Cell: d => (
                      <div>
                        <Popconfirm
                          title="Are you sure you want to make a copy of this Estimate?"
                          onConfirm={() => this.handleClone(d.original)}
                          onCancel={this.cancelDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button
                            size="small"
                            icon="copy"
                            type="copy"
                            style={{ color: '#1F45B4' }}
                          />
                        </Popconfirm>
                      </div>
                    ),
                    width: 100
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (
  {
    jobSiteEstimateActions,
    itemActions,
    estimateTemplate,
    jobSiteChangeOrderActions,
    jobVendorActions,
    authentication,
    revisionActions
  },
  ownProps
) => ({
  jobSiteEstimateActions,
  itemActions,
  estimateTemplate,
  jobSiteChangeOrderActions,
  jobVendorActions,
  authentication,
  revisionActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      itemActions,
      jobSiteEstimateActions,
      estimateTemplateActions,
      jobSiteChangeOrderActions,
      jobVendorActions,
      revisionActions
    ),
    dispatch
  )
})
JobSiteEstimates.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobSiteEstimates))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteEstimates.js